import FormHistoryScreen from '@/pages/forms-history-screen.vue';
import FormsManager from '@/pages/global-forms-manager.vue';

export default [
	{
		name: 'form-history',
		path: '/forms/:changedEntityId/history',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search || '',
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			changedEntityId: route.params.changedEntityId,
			page: parseInt(route.query.page) || 1,
			countPerPage: parseInt(route.query.countPerPage) || 10
		}),
		component: FormHistoryScreen,
		meta: {
			permissions: ['forms.read']
		}
	},
	{
		name: 'impact-form-add-designer',
		path: '(/clients/)?:customerId?/forms/add/impact',
		props: route => ({
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/impact-form-designer.vue'
			),
		meta: {
			permissions: ['forms.create']
		}
	},
	{
		name: 'impact-form-edit-designer',
		path: '(/clients/)?:customerId?/forms/edit/:id(\\d+)/impact',
		props: route => ({
			id: parseInt(route.params.id),
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/impact-form-designer.vue'
			),
		meta: {
			permissions: ['forms.update']
		}
	},
	{
		name: 'impact-form-copy-designer',
		path: '(/clients/)?:customerId?/forms/copy/:id(\\d+)/impact',
		props: route => ({
			id: parseInt(route.params.id),
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/impact-form-designer.vue'
			),
		meta: {
			permissions: ['forms.create']
		}
	},
	{
		name: 'laser-form-add-designer',
		path: '(/clients/)?:customerId?/forms/add/laser',
		props: route => ({
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/laser-form-designer.vue'
			),
		meta: {
			permissions: ['forms.create']
		}
	},
	{
		name: 'laser-form-edit-designer',
		path: '(/clients/)?:customerId?/forms/edit/:id(\\d+)/laser',
		props: route => ({
			id: parseInt(route.params.id),
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/laser-form-designer.vue'
			),
		meta: {
			permissions: ['forms.update']
		}
	},
	{
		name: 'laser-form-copy-designer',
		path: '(/clients/)?:customerId?/forms/copy/:id(\\d+)/laser',
		props: route => ({
			id: parseInt(route.params.id),
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/laser-form-designer.vue'
			),
		meta: {
			permissions: ['forms.create']
		}
	},
	{
		name: 'laser-form-preview-designer',
		path: '(/clients/)?:customerId?/forms/preview/:id(\\d+)/laser',
		props: route => ({
			id: parseInt(route.params.id),
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/laser-form-designer-read-only.vue'
			),
		meta: {
			permissions: ['forms.read']
		}
	},
	{
		name: 'impact-form-preview-designer',
		path: '(/clients/)?:customerId?/forms/preview/:id(\\d+)/impact',
		props: route => ({
			id: parseInt(route.params.id),
			customerId: route.params.customerId
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/pages/impact-form-designer-read-only.vue'
			),
		meta: {
			permissions: ['forms.read']
		}
	},
	{
		name: 'forms-manager',
		path: '/forms',
		component: FormsManager,
		props: route => ({
			search: route.query.search,
			sortBy: route.query.sortBy || 'date',
			sortDirection: route.query.sortDirection || 'desc',
			type: route.query.type || 'all',
			status: route.query.status || 'active'
		}),
		meta: {
			permissions: ['forms.read']
		}
	}
];
